import PropTypes from "prop-types";
import Price from "../../../Price/Price";
import coinsIcon from "../../../../assets/icons/coins.svg";
import walletBannerVector from "../../../../assets/icons/wallet_banner_vector.svg";
import classes from "./WalletBanner.module.css";

const WalletBanner = (props) => {
  const { balance } = props;

  return (
    <div className={classes["wallet-banner"]}>
      <div className={classes["wallet-banner__balance-wrapper"]}>
        <p className={classes["wallet-banner__balance-title"]}>رصيدي الحالي</p>
        <Price
          value={balance}
          valueClassName={classes["wallet-banner__balance"]}
        />
      </div>
      <img
        src={coinsIcon}
        alt="coins"
        className={classes["wallet-banner__coins"]}
      />
      <img
        src={walletBannerVector}
        alt="mtor"
        className={classes["wallet-banner__vector"]}
      />
    </div>
  );
};

export default WalletBanner;

WalletBanner.propTypes = {
  balance: PropTypes.number,
};
